export const socialsData = {
    github: 'https://github.com/mullaguraharish',
    facebook: 'https://www.facebook.com/people/Harish-Chowdary/100017436559502/',
    linkedIn: 'https://www.linkedin.com/in/harish-mullagura/',
    instagram: 'https://www.instagram.com/harish_chowdary_2519/?hl=en',
    codepen: 'https://codepen.io/',
    leetcode: 'https://leetcode.com/harish2503/',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    hackerrank:'https://www.hackerrank.com/harish_m25',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    codechef: 'https://www.codechef.com/users/harish_1925',
    twitter:'https://twitter.com/Harish250302',
    youtube:'https://www.youtube.com/channel/UCCF07l7p-1E0LPdUIDlhxww',
}
